export default "__VITE_ASSET__lhlN3cyw__"